const units = ['B', 'KB', 'MB', 'G', 'T'];
export function getFileSize(size, unit = 1000) {
    if (!size)
        return '';
    const power = Math.floor(Math.log10(size) / Math.log10(unit)); // console.log('power',power)
    const base = Math.min(power, 4); // 最大单位是T
    return (size / Math.pow(unit, base)).toFixed(2) + units[base];
}
